import regionCheck from "./endpoints/regionCheck";
import actualRegion from "./endpoints/actualRegion"

export default {regionCheck, actualRegion}